import { getMilliSecondsFromDate } from './formatters';

export const isDateExpired = (date: string | undefined | null): boolean =>
    !date || getMilliSecondsFromDate(date) < Date.now();
